import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import Pagination from '@material-ui/lab/Pagination'


const useStyles = makeStyles(() => ({
  root: {
    '& .MuiPaginationItem-root': {
      'font-size': '15px'
    },
    '& .MuiPagination-ul': {
      'justify-content': 'center',
      'flex-wrap': 'nowrap'
    },
    '& .Mui-selected': {
      color: 'white',
      'background-color': '#45b5f5'
    },
    '& .Mui-selected:hover': {
      'background-color': '#45b5f5'
    }
  }
}))

export default function Paginator(props: { count?: number, page?: number, onChange?: (event: React.ChangeEvent<unknown>, page: number) => void }) {
  const classes = useStyles()
  const { count, page, onChange  } = props

  return (
    <Pagination
      classes={{ root: classes.root }}
      page={page}
      onChange={onChange}
      count={count}
    />
  )
}